const data = [
  {
    id: 1,
    name: '管理者 太郎10',
    name_alphabetical: 'kanrisyatarou',
    overview: '概要です',
    header: 2,
    short_message: '一言です',
    notice: 'お知らせです',
    image_url:
      'https://ucc-coffee-creation-dev.s3.ap-northeast-1.amazonaws.com/resource/image/barista/WUh8NUllDVQ8RJ0TeHCRqIs3PXpsiWIJbZFfvjkA.png',
    is_publishable: true,
    created_at: '2022-09-08T09:10:33.000000Z',
    updated_at: '2022-09-16T08:14:27.000000Z',
    is_favorite: true,
    tags: [
      {
        id: 1,
        name: 'コーヒー'
      },
      {
        id: 2,
        name: 'アメリカ'
      },
      {
        id: 3,
        name: 'イタリア'
      }
    ],
    products: [
      {
        id: 37,
        name: '公開_製品_推奨サムネ_キャンペーン利用_感想登録_pro公開_JAN',
        image_url: 'https://placehold.jp/375x800.png'
      },
      {
        id: 38,
        name: '公開_製品_推奨サムネ_キャンペーン利用_感想登録_pro公開_JAN',
        image_url: 'https://placehold.jp/375x800.png'
      },
      {
        id: 39,
        name: '公開_製品_推奨サムネ_キャンペーン利用_感想登録_pro公開_JAN',
        image_url: 'https://placehold.jp/375x800.png'
      },
      {
        id: 40,
        name: '公開_製品_推奨サムネ_キャンペーン利用_感想登録_pro公開_JAN',
        image_url: 'https://placehold.jp/375x800.png'
      },
      {
        id: 41,
        name: '公開_製品_推奨サムネ_キャンペーン利用_感想登録_pro公開_JAN',
        image_url: 'https://placehold.jp/375x800.png'
      },
      {
        id: 42,
        name: '公開_製品_推奨サムネ_キャンペーン利用_感想登録_pro公開_JAN',
        image_url: 'https://placehold.jp/375x800.png'
      }
    ],
    events: [
      {
        id: 1,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 5,
        image_url: 'https://placehold.jp/80x80.png',
        catchphrase:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし!"#$%&\'()=~|{`}*+_?><',
        title:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_10マイル',
        link_url: null,
        description:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        venue_name:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        venue_address: '東京都港区新橋6丁目1-11',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/80x80.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 7,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間内_開催時間（単数）後_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-01-01 13:00:00',
            end_at: '2022-01-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 8,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間内_開催時間（複数）後_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-01-01 13:00:00',
            end_at: '2022-01-01 18:00:00'
          },
          {
            start_at: '2022-01-02 13:00:00',
            end_at: '2022-01-02 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 9,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間内_開催時間（複数）の片方後_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-01-01 13:00:00',
            end_at: '2022-01-01 18:00:00'
          },
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 10,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間前_開催時間（単数）前_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 11,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間後_開催時間（単数）前_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 12,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 16,
        image_url: 'https://placehold.jp/80x80.png',
        catchphrase:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし!"#$%&\'()=~|{`}*+_?><',
        title:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_10マイル',
        link_url: null,
        description:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        venue_name:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        venue_address: '東京都港区新橋6丁目1-11',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/80x80.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 18,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間内_開催時間（単数）後_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-01-01 13:00:00',
            end_at: '2022-01-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 19,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間内_開催時間（複数）後_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-01-01 13:00:00',
            end_at: '2022-01-01 18:00:00'
          },
          {
            start_at: '2022-01-02 13:00:00',
            end_at: '2022-01-02 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 20,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間内_開催時間（複数）の片方後_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-01-01 13:00:00',
            end_at: '2022-01-01 18:00:00'
          },
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 21,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間前_開催時間（単数）前_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 22,
        image_url: 'https://placehold.jp/375x230.png',
        catchphrase:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイル',
        title:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像推奨サイズ1枚_告知期間後_開催時間（単数）前_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_5マイル',
        link_url: null,
        description:
          '公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。公開_推奨サムネ_プロ1人_適切な文章_関連画像1枚_告知期間内_開催時間（単数）内_地図カテゴリ住所_存在する住所_注目リンクカードなし_プロコーヒーあり_マイルのテストです。',
        venue_name: '開催場所',
        venue_address: '東京都新宿区築地町3番地神楽坂テクノス3F',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/280x160.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      }
    ],
    movies: [
      {
        id: 15,
        title: '【必見！】コーヒー鑑定士のディープな世界',
        description:
          '今回は、ブラジルコーヒー鑑定士の資格を持つ川口講師にお越しいただきました！世界最大のコーヒー生産国ブラジルでは、どんな方法でコーヒーの品質が守られているのでしょうか。\nたまに生産国に思いをはせながら、コーヒーを楽しんでみてくださいね♪',
        image_url: 'https://placehold.jp/375x800.png',
        movie_url: 'https://youtu.be/qy9eO_2Xi78'
      }
    ]
  },
  {
    id: 2,
    name: '村田 果穂',
    name_alphabetical: 'Miho Murata',
    overview: 'UCCコーヒーアカデミー勤務。',
    header: 1,
    short_message: null,
    notice: null,
    image_url: 'https://www.ufs.co.jp/professionals/img/murata.png',
    is_publishable: true,
    created_at: '2022-09-08T09:10:33.000000Z',
    updated_at: '2022-09-08T09:10:33.000000Z',
    is_favorite: true,
    tags: [],
    products: [],
    events: [
      {
        id: 2,
        image_url: 'https://placehold.jp/900x230.png',
        catchphrase:
          '公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなし公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなし公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所',
        title:
          '公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内終了期限なし_開催時間（複数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_5マイル',
        link_url: null,
        description:
          '公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。',
        venue_name:
          '開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所',
        venue_address: 'テスト',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/800x160.png"},{"image_url":"https:\\/\\/placehold.jp\\/800x160.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          },
          {
            start_at: '2022-05-01 13:00:00',
            end_at: '2022-05-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 5,
        image_url: 'https://placehold.jp/80x80.png',
        catchphrase:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし!"#$%&\'()=~|{`}*+_?><',
        title:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_10マイル',
        link_url: null,
        description:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        venue_name:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        venue_address: '東京都港区新橋6丁目1-11',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/80x80.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 13,
        image_url: 'https://placehold.jp/900x230.png',
        catchphrase:
          '公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなし公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなし公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所',
        title:
          '公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内終了期限なし_開催時間（複数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_5マイル',
        link_url: null,
        description:
          '公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。公開_横長サムネ_プロ2人_やたら長い文章_関連画像横長サイズ2枚_告知期間内_開催時間（単数）前_地図カテゴリ住所_存在しない住所_注目リンクカードあり_プロコーヒーなし_マイルなしのテストです。',
        venue_name:
          '開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所開催場所',
        venue_address: 'テスト',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場所説明。開催場',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/800x160.png"},{"image_url":"https:\\/\\/placehold.jp\\/800x160.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          },
          {
            start_at: '2022-05-01 13:00:00',
            end_at: '2022-05-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 16,
        image_url: 'https://placehold.jp/80x80.png',
        catchphrase:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし!"#$%&\'()=~|{`}*+_?><',
        title:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_10マイル',
        link_url: null,
        description:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        venue_name:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        venue_address: '東京都港区新橋6丁目1-11',
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution:
          '公開_やたら小さいサムネ_プロ4人_やたら記号使う文章_関連画像小さいサイズ1枚_告知期間内_開催時間（複数）前_地図カテゴリ住所_注目リンクカードあり_プロコーヒー複数_マイルなし\n!"#$%&\'()=~|{`}*+_?><',
        additional_images:
          '[{"image_url":"https:\\/\\/placehold.jp\\/80x80.png"}]',
        schedules: [
          {
            start_at: '2022-04-01 13:00:00',
            end_at: '2022-04-01 18:00:00'
          }
        ],
        reward: [
          {
            id: 11,
            name: 'イベント用マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 30,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 39,
        image_url:
          'https://ucc-coffee-creation-dev.s3.ap-northeast-1.amazonaws.com/resource/image/event/lK5cvu7fWBUrfpwEYzFzG59U5egylXnh1rFb6sM3.png',
        catchphrase: 'テストです',
        title: 'サムネイル表示比率のテスト',
        link_url: null,
        description: 'テストです',
        venue_name: 'ここ',
        venue_address: null,
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution: null,
        additional_images: null,
        schedules: [
          {
            start_at: '2022-09-20 17:00:00',
            end_at: '2022-09-20 18:00:00'
          }
        ],
        reward: [
          {
            id: 12,
            name: '100マイルプラスインセンティブ',
            description: null,
            warning: null,
            type: 1,
            amount: 100,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 40,
        image_url:
          'https://ucc-coffee-creation-dev.s3.ap-northeast-1.amazonaws.com/resource/image/event/2mlC7tz0oN2yp2ikCTCZeiQ0CGCu56wHa5K6z9QJ.png',
        catchphrase: 'テストです',
        title: '表示テスト',
        link_url: null,
        description: 'テストです',
        venue_name: 'ここ',
        venue_address: null,
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution: null,
        additional_images: null,
        schedules: [
          {
            start_at: '2022-09-20 17:00:00',
            end_at: '2022-09-20 18:00:00'
          }
        ],
        reward: [
          {
            id: 8,
            name: 'キャンペーン用_ストア連携_マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 1,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 41,
        image_url:
          'https://ucc-coffee-creation-dev.s3.ap-northeast-1.amazonaws.com/resource/image/event/6d7R8FuUnKECOnjJJRJi2Lc2d7E8tnxQZM9w5ixB.png',
        catchphrase: 'テストです',
        title: 'テスト',
        link_url: null,
        description: 'テストです',
        venue_name: 'ここ',
        venue_address: null,
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution: null,
        additional_images: null,
        schedules: [
          {
            start_at: '2022-09-20 17:00:00',
            end_at: '2022-09-20 18:00:00'
          }
        ],
        reward: [
          {
            id: 8,
            name: 'キャンペーン用_ストア連携_マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 1,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 48,
        image_url:
          'https://ucc-coffee-creation-dev.s3.ap-northeast-1.amazonaws.com/resource/image/event/yu2QzLmmG9ZQMYrs9taPiNTEXYmY53gCRbKmQk9Y.png',
        catchphrase: 'あああ',
        title: 'あああ',
        link_url: null,
        description: 'あああ',
        venue_name: 'あああ',
        venue_address: null,
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution: null,
        additional_images: null,
        schedules: [
          {
            start_at: '2022-09-20 17:00:00',
            end_at: '2022-09-20 18:00:00'
          }
        ],
        reward: [
          {
            id: 12,
            name: '100マイルプラスインセンティブ',
            description: null,
            warning: null,
            type: 1,
            amount: 100,
            coupon_code: null,
            image_url: null
          }
        ]
      },
      {
        id: 49,
        image_url:
          'https://ucc-coffee-creation-dev.s3.ap-northeast-1.amazonaws.com/resource/image/event/sKunezoSuUVkEVKzdMMtEDy0kolnmhIC1ggfMMnf.png',
        catchphrase: 'あああ',
        title: 'テスト',
        link_url: null,
        description: 'あああ',
        venue_name: 'あああ',
        venue_address: null,
        venue_latitude: null,
        venue_longitude: null,
        price: 0,
        caution: null,
        additional_images: null,
        schedules: [
          {
            start_at: '2022-09-20 17:00:00',
            end_at: '2022-09-20 18:00:00'
          }
        ],
        reward: [
          {
            id: 8,
            name: 'キャンペーン用_ストア連携_マイル',
            description: null,
            warning: null,
            type: 1,
            amount: 1,
            coupon_code: null,
            image_url: null
          }
        ]
      }
    ]
  }
];

export { data };
